<loading *ngIf="loading" class="full">
  <ng-container i18n="@@cryptoPrices.loading">Loading data...</ng-container>
</loading>

<error *ngIf="error" class="full">
  {{error}}
</error>

<div *ngIf="!loading && !error" class="dashboard-panel glass-panel">
  <!-- Controls toolbar — Desktop -->
  <div class="controls-bar desktop-controls">
    <div class="controls-row">
      <div class="fiat-selector">
        <ng-container *ngFor="let currency of fiatCurrencies">
          <a href="javascript: void(0);" class="fiat-pill" [class.active]="currency.code === fiatCurrency" (click)="setFiatCurrency(currency.code)">{{currency.code}}</a>
        </ng-container>
      </div>

      <div class="search-wrapper">
        <search-input
          class="full-view"
          [value]="searchValue"
          [maxlength]="20"
          [formControl]="searchControl"
          placeholder="Search for a Coin, Token here..."
          i18n-placeholder="@@serch.placeholder">
        </search-input>
      </div>

      <div class="duration-wrapper">
        <chart-duration-picker [duration]="duration" (durationChange)="changeDuration($event)"></chart-duration-picker>
      </div>

      <div class="view-toggle">
        <button class="view-btn" [class.active]="viewMode === 'table'" (click)="setViewMode('table')" title="Table view">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="1" y="2" width="14" height="2.5" rx="0.5" fill="currentColor"/><rect x="1" y="6.75" width="14" height="2.5" rx="0.5" fill="currentColor"/><rect x="1" y="11.5" width="14" height="2.5" rx="0.5" fill="currentColor"/></svg>
        </button>
        <button class="view-btn" [class.active]="viewMode === 'card'" (click)="setViewMode('card')" title="Card view">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="1" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="1" y="9" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="9" width="6" height="6" rx="1.5" fill="currentColor"/></svg>
        </button>
      </div>
    </div>
  </div>

  <!-- Controls toolbar — Mobile -->
  <div class="controls-bar mobile-controls">
    <div class="mobile-controls-top">
      <select class="mobile-select" [ngModel]="fiatCurrency" (ngModelChange)="setFiatCurrency($event)">
        <ng-container *ngFor="let currency of fiatCurrencies">
          <option [value]="currency.code">{{currency.code}}</option>
        </ng-container>
      </select>
      <select class="mobile-select" [ngModel]="duration" (ngModelChange)="changeDuration($event)">
        <ng-container *ngFor="let opt of durationOptions">
          <option [value]="opt.value">{{opt.label}}</option>
        </ng-container>
      </select>
      <label class="chart-toggle">
        <input type="checkbox" [checked]="showCharts" (change)="toggleCharts()">
        <span class="toggle-track"><span class="toggle-thumb"></span></span>
        <i class="icon-pro toggle-icon"></i>
      </label>
      <div class="view-toggle">
        <button class="view-btn" [class.active]="viewMode === 'table'" (click)="setViewMode('table')" title="Table view">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="1" y="2" width="14" height="2.5" rx="0.5" fill="currentColor"/><rect x="1" y="6.75" width="14" height="2.5" rx="0.5" fill="currentColor"/><rect x="1" y="11.5" width="14" height="2.5" rx="0.5" fill="currentColor"/></svg>
        </button>
        <button class="view-btn" [class.active]="viewMode === 'card'" (click)="setViewMode('card')" title="Card view">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><rect x="1" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="1" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="1" y="9" width="6" height="6" rx="1.5" fill="currentColor"/><rect x="9" y="9" width="6" height="6" rx="1.5" fill="currentColor"/></svg>
        </button>
      </div>
    </div>
    <div class="mobile-controls-search">
      <search-input
        class="full-view"
        [value]="searchValue"
        [maxlength]="20"
        [formControl]="searchControl"
        placeholder="Search for a Coin, Token here..."
        i18n-placeholder="@@serch.placeholder">
      </search-input>
    </div>
  </div>

  <!-- Table header -->
  <div *ngIf="showHeader && viewMode === 'table'" class="table-header row d-none d-lg-flex">
    <div class="col-3 sortable-header" (click)="toggleSort('name')">
      <span i18n="@@cryptoPrices.header.digitalAsset">Digital Asset</span>
      <span class="sort-arrows" [class.active-column]="sortColumn === 'name'">
        <span class="arrow-up" [class.active]="sortColumn === 'name' && sortDirection === 'asc'">&#9650;</span>
        <span class="arrow-down" [class.active]="sortColumn === 'name' && sortDirection === 'desc'">&#9660;</span>
      </span>
    </div>
    <div class="col-2 sortable-header" (click)="toggleSort('price')">
      <span i18n="@@cryptoPrices.header.price">Price</span>
      <span class="sort-arrows" [class.active-column]="sortColumn === 'price'">
        <span class="arrow-up" [class.active]="sortColumn === 'price' && sortDirection === 'asc'">&#9650;</span>
        <span class="arrow-down" [class.active]="sortColumn === 'price' && sortDirection === 'desc'">&#9660;</span>
      </span>
    </div>
    <div class="col-2 sortable-header" (click)="toggleSort('change')">
      <ng-container *ngTemplateOutlet="changeColumnHeader; context: {duration: duration}"></ng-container>
      <span class="sort-arrows" [class.active-column]="sortColumn === 'change'">
        <span class="arrow-up" [class.active]="sortColumn === 'change' && sortDirection === 'asc'">&#9650;</span>
        <span class="arrow-down" [class.active]="sortColumn === 'change' && sortDirection === 'desc'">&#9660;</span>
      </span>
    </div>
    <div class="col-2">
      <ng-container *ngTemplateOutlet="chartColumnHeader; context: {duration: duration}"></ng-container>
    </div>
    <div class="col-1"></div>
    <div class="col-2"></div>
  </div>

  <!-- Items list (single loop, layout controlled by CSS + cardMode input) -->
  <div class="items-container" [class.card-grid]="viewMode === 'card'">
    <div class="empty-state" *ngIf="searchControl.value && !filteredCurrencies.length">
      <p i18n="@@cryptoPrices.search.nothing">Nothing found for "<span class="search-result">{{ searchControl.value }}</span>"</p>
      <button class="btn-glass-outline clear-btn" (click)="clearSearchValue()" i18n="@@core2.currencyModal.empty.action">Clear search</button>
    </div>
    <ng-container *ngFor="let currency of sortedCurrencies; trackBy: trackByCurrencyCode;">
      <crypto-list-item
        *ngIf="filteredCurrencies?.includes(currency.code)"
        [currency]="currency"
        [baseCurrencyCode]="fiatCurrency"
        [duration]="duration"
        [cardMode]="viewMode === 'card'"
        [showCharts]="showCharts"
        [isFavorite]="isFavorite(currency.code)"
        (favoriteToggle)="toggleFavorite($event)"
        (update)="onDataChange($event)">
      </crypto-list-item>
    </ng-container>
  </div>
</div>

<div *ngIf="showUpdateDate" class="update-time" i18n="@@cryptoPrices.lastUpdated">Prices Last Updated: {{lastUpdateDate | date:'medium'}}</div>


<ng-template #changeColumnHeader let-duration="duration">
  <span [ngSwitch]="duration">
    <ng-container *ngSwitchCase="PriceChartDuration.OneDay" i18n="@@pricePage.change.headerTitle.24hours">Change (24 Hours)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.SevenDays" i18n="@@pricePage.change.headerTitle.7days">Change (7 Days)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneMonth" i18n="@@pricePage.change.headerTitle.1month">Change (1 Month)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.ThreeMonths" i18n="@@pricePage.change.headerTitle.3months">Change (3 Months)
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneYear" i18n="@@pricePage.change.headerTitle.1year">Change (1 Year)
    </ng-container>
    <ng-container *ngSwitchDefault i18n="@@pricePage.change.durations.24hours">Change (24 Hours)
    </ng-container>
  </span>
</ng-template>

<ng-template #chartColumnHeader let-duration="duration">
  <span [ngSwitch]="duration">
    <ng-container *ngSwitchCase="PriceChartDuration.OneDay" i18n="@@pricePage.chart.headerTitle.24hours">24 Hours Chart</ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.SevenDays" i18n="@@pricePage.chart.headerTitle.7days">7 Days Chart
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneMonth" i18n="@@pricePage.chart.headerTitle.1month">1 Month Chart
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.ThreeMonths" i18n="@@pricePage.chart.headerTitle.3months">3 Months
      Chart
    </ng-container>
    <ng-container *ngSwitchCase="PriceChartDuration.OneYear" i18n="@@pricePage.chart.headerTitle.1year">1 Year Chart
    </ng-container>
    <ng-container *ngSwitchDefault i18n="@@pricePage.chart.headerTitle.24hours">24 Hours Chart</ng-container>
  </span>
</ng-template>
